import React from "react";
import _ from "lodash";
import {
  CommonSubmitButton,
  LoaderType,
  RenderForm,
  showNotification,
  SwitchLoader,
} from "../../../common";
import API from "../../../common/AxoisClient";
import { useHistory } from "react-router-dom";
import { SSOSettingModel } from "../../../model/SSOSetting";
import { IState } from "../Data";
import { SSOValidations } from "../Validation";

export const PageForm = (props: IState) => {
  let history = useHistory();
  const [form, setForm] = React.useState({} as SSOSettingModel);
  const [formValid, setFormValid] = React.useState(true); // track jquery validation

  const handleChange = (event: React.ChangeEvent<HTMLElement>) => {
    const target: any = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setForm({ ...form, [name]: value });
  };

  React.useEffect(() => {
    setForm(props.ssoSetting);
  }, [props.ssoSetting]);

  // setup jquery validation & events
  React.useEffect(() => {
    SSOValidations();

    const $form = $("#sso_setting_form");

    // whenever form is validated, update state
    $form.on("keyup blur change", "input, textarea, select", function () {
      setFormValid($form.valid());
    });

    return () => {
      $form.off("keyup blur change"); // cleanup
    };
  }, []);

  const FormInputs = [
    {
      name: "name",
      value: _.get(form, "name", ""),
      onChange: handleChange,
      required: true,
      placeholder: "Enter Page name",
      label: "Name",
    },
    {
      name: "clientId",
      value: _.get(form, "client_id", ""),
      onChange: handleChange,
      disabled: true,
      placeholder: "Enter clientId",
      label: "ClientId",
    },
    {
      name: "whitelisted_domains",
      value: _.get(form, "whitelisted_domains", ""),
      onChange: handleChange,
      required: true,
      placeholder: "Enter domains (comma separated)",
      type: "textarea",
      label: "Domains",
      parent_class: "col-md-12 col-lg-12",
    },
  ];

  function isDisable() {
    const hasEmptyRequired = FormInputs.some(
      (val) => val.required && (val.value === "" || val.value === null)
    );
    return hasEmptyRequired || !formValid;
  }

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const $form = $("#sso_setting_form");
    if (!$form.valid()) {
      setFormValid(false);
      return;
    }

    SwitchLoader(LoaderType.BUTTON);

    const payload = {
      ...form,
      whitelisted_domains:
        typeof form.whitelisted_domains === "string"
          ? form.whitelisted_domains
              .split(",")
              .map((d) => d.trim())
              .filter((d) => d.length > 0)
          : form.whitelisted_domains,
    };

    API.put(`settings/sso-setting/${props.id}`, payload)
      .then((res) => {
        showNotification("success", res.data.message);
        history.push(`/settings/sso-setting`);
      })
      .catch(() => {});
  };

  return (
    <form className="kt-form" id={"sso_setting_form"} onSubmit={handleSubmit}>
      <div className="kt-portlet__body">
        <div className={"row"}>
          <RenderForm items={FormInputs} />
        </div>
      </div>
      <CommonSubmitButton disabled={isDisable()} />
    </form>
  );
};
